import React, { useState, useEffect } from "react";
import FiltroModal from "../../components/Relatorios/inventarioFiltro";
import RelatorioInventarioCliente from "../../components/Relatorios/relatorioInventario";
import { getInventarioEmpresa, getInventarioUnidade } from "../../services/api_inventario_cliente";
import { getInventarioCliente } from "../../services/api_inventario_cliente";
import Swal from "sweetalert2";

const InventarioPage = () => {
    const [showForm, setShowForm] = useState(true);
    const [showRelatorio, setShowRelatorio] = useState(false);
    const [filtro, setFiltro] = useState({});
    const [dadosRelatorio, setDadosRelatorio] = useState([]);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      if (loading) {
        Swal.fire({
          title: "Gerando relatório...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
      } else {
        Swal.close();
      }
    }, [loading]);

    const handleGenerateRelatorio = async (filtro) => {
      try {
        setLoading(true);
        let body = {
          idEmpresa:filtro.empresa,
          idUnidade:filtro.unidade
        }
        // Combine os dados de diferentes fontes em um único array
        const dados = await getInventarioCliente(body);
  
        console.log("eita:", dados);
  
        setFiltro({
          nomeEmpresa: filtro.nomeEmpresa,
          nomeUnidade: filtro.nomeUnidade,
        });
        setDadosRelatorio(dados);
        setShowForm(false);
        setShowRelatorio(true);
        setLoading(false);
  
        // console.log(dadosFiltrados)
      } catch (error) {
        console.error("Erro ao gerar relatório:", error);
      }
    };

  return (
    <div>
      {showForm && (
          <FiltroModal
            show={showForm}
            handleClose={() => setShowForm(false)}
            handleGenerate={handleGenerateRelatorio}
          />
        )}
        {showRelatorio && (
          <RelatorioInventarioCliente
            filtro={filtro}
            dataHora={new Date().toLocaleString()}
            dados={dadosRelatorio}
            setShowForm={setShowForm} // Passa a função para mostrar o formulário
            setShowRelatorio={setShowRelatorio} // Passa a função para esconder o relatório
          />
        )}
    </div>
  );
};

export default InventarioPage;

